<template>
  <el-dialog
    :visible.sync="dialogTableVisible"
    :show-close="false"
    :z-index="7"
    top="200px"
    :close-on-press-escape="false"
    class="g-msg-repair-dialog"
    width="480px"
  >
    <div style="color: #fdd99b; text-align: center; padding-top: 30px">
      选择客服类型
    </div>
    <div class="justify-around" style="padding-bottom: 50px; padding-top: 30px">
      <div
        v-for="(item, index) in serveDataV2"
        :key="index"
        class="cp-button-main cp-popup-button m-b-0"
        style="color: #774230"
        @click="jumpToService(item.url)"
      >
        {{ item.name }}
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'RepairDilog',
  data() {
    return {
      dialogTableVisible: false,
    };
  },
  computed: {
    serveDataV2() {
      return this.$store.state.serveDataV2;
    },
  },
  methods: {
    open() {
      this.dialogTableVisible = true;
    },
    jumpToService(url) {
      window.open(url);
      this.dialogTableVisible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.g-msg-repair-dialog {
  .el-dialog {
    background-color: #774230 !important ;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    background: #774230;
    padding: 16px 24px;
    color: #fff;
  }
  /* 内容区背景 */
}
/* 内容区背景 */
:deep(.el-dialog__body) {
  background-color: #774230;
  color: #fff;
  display: block !important;
  height: auto !important;
}
</style>
